import { useMemo } from 'react';
import { useAudioPlayerState } from '@trinity/chat-components/containers/AudioPlayer/Context';
import type { TextToSpeechState, TextToSpeechAudioMetadata } from './Context';

export function useTTSState() {
  const [state] = useAudioPlayerState();

  return useMemo((): TextToSpeechState => {
    const metadata = state.metadata as TextToSpeechAudioMetadata;
    return {
      kolSearchId: metadata?.kolSearchId,
      queryId: metadata?.queryId,
      state: computeTTSState(
        state.playing,
        state.stopped,
        metadata,
      ),
    };
  }, [
    state.metadata,
    state.stopped,
    state.playing,
  ]);
}


function computeTTSState(
  isPlaying: boolean,
  isStopped: boolean,
  metadata: TextToSpeechAudioMetadata,
): TextToSpeechState['state'] {

  if (isPlaying) {
    return 'playing';
  }

  if (metadata.loadingState === 'loading') {
    return 'loading';
  }
  if (metadata.loadingState === 'error') {
    return 'error';
  }
  if (isStopped) {
    return 'stopped';
  }
  return 'paused';
}